import Slider from './components/slider/slider.component';

function App() {
  return (
    <div className="App">
      <Slider />
    </div>
  );
}

export default App;
